<ng-container>
  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-4">
        <div class="col-md-6">
          <span class="d-flex justify-content-start align-items-center">
            <i
              (click)="goBack()"
              class="fa fa-arrow-left pointer mr-2"
              aria-hidden="true"></i>
            <h1 class="payment-history-title">Partial Credit Note</h1>
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4 col-sm-4 col-xs-6">
          <span class="label-style">Name :</span>

          {{ invoiceDetails.quotation?.client?.name }}
        </div>

        <div class="col-md-4 col-sm-4 col-xs-6">
          <span class="label-style">Currency :</span>

          {{ invoiceDetails.quotation?.currency?.code }}
          <!------------------ service order for acm partial credit note --->
          <ng-container *ngIf="module === constants.ACM_PARTIAL">
            {{ invoiceDetails.serviceOrder?.currency?.code }}
          </ng-container>
        </div>

        <ng-container
          *ngIf="
            invoiceDetails?.quotation?.totalOutOfScope ||
            invoiceDetails?.serviceOrder?.totalOutOfScope
          ">
          <div class="col-md-4 col-sm-4 col-xs-6">
            <span class="label-style"> Total (Excluding VAT) :</span>

            <ng-container>
              <span>
                {{ invoiceDetails.quotation?.currency?.code }}
              </span>
              {{ totalExVat | number: '1.2-2' }}
            </ng-container>
          </div>

          <div class="col-md-4 col-sm-4 col-xs-6">
            <span class="label-style"> Total Out Of Scope : </span>
            <ng-container>
              <span>
                {{ invoiceDetails.quotation?.currency?.code }}
              </span>
              {{ invoiceDetails.quotation?.totalOutOfScope | number: '1.2-2' }}
            </ng-container>
            <ng-container *ngIf="module === constants.ACM_PARTIAL">
              <span>
                {{ invoiceDetails.serviceOrder?.currency?.code }}
              </span>
              {{
                invoiceDetails.serviceOrder?.totalOutOfScope | number: '1.2-2'
              }}
            </ng-container>
          </div>
        </ng-container>

        <div class="col-md-4 col-sm-4 col-xs-6">
          <span class="label-style"> Total Taxable Amount :</span>
          <ng-container *ngIf="module !== constants.ACM_PARTIAL">
            <span>
              {{ invoiceDetails.quotation?.currency?.code }}
            </span>
            {{ taxableAmount | number: '1.2-2' }}
          </ng-container>
          <ng-container *ngIf="module === constants.ACM_PARTIAL">
            <span>
              {{ invoiceDetails.serviceOrder?.currency?.code }}
            </span>
            {{ taxableAmount | number: '1.2-2' }}
          </ng-container>
        </div>

        <div class="col-md-4 col-sm-4 col-xs-6">
          <span class="label-style">Total Vat (15%) :</span>
          <ng-container>
            <span>
              {{ invoiceDetails.quotation?.currency?.code }}
            </span>
            {{ invoiceDetails.quotation?.vatAmount | number: '1.2-2' }}
          </ng-container>
          <!------------------ service order for acm partial credit note --->
          <ng-container *ngIf="module === constants.ACM_PARTIAL">
            <span>
              {{ invoiceDetails.serviceOrder?.currency?.code }}
            </span>
            {{ invoiceDetails.serviceOrder?.vatAmount | number: '1.2-2' }}
          </ng-container>
        </div>

        <div class="col-md-4 col-sm-4 col-xs-6">
          <span class="label-style">Credit Balace :</span>

          <ng-container *ngIf="module !== constants.ACM_PARTIAL">
            <span *ngIf="invoiceDetails.quotation?.creditBalance">
              {{ invoiceDetails.quotation?.currency?.code }}
            </span>

            {{ invoiceDetails.quotation?.creditBalance | number: '1.2-2' }}
          </ng-container>
          <ng-container *ngIf="module === constants.ACM_PARTIAL">
            <span *ngIf="invoiceDetails.quotation?.creditBalance">
              {{ invoiceDetails.serviceOrder?.currency?.code }}
            </span>

            {{ invoiceDetails.quotation?.creditBalance | number: '1.2-2' }}
          </ng-container>
        </div>

        <div class="col-md-4 col-sm-4 col-xs-6">
          <span class="label-style">Total :</span>

          <ng-container *ngIf="module !== constants.ACM_PARTIAL">
            <span *ngIf="invoiceDetails.quotation?.total">
              {{ invoiceDetails.quotation?.currency?.code }}
            </span>

            {{ invoiceDetails.quotation?.total | number: '1.2-2' }}
          </ng-container>

          <ng-container *ngIf="module === constants.ACM_PARTIAL">
            <span *ngIf="invoiceDetails.serviceOrder?.total">
              {{ invoiceDetails.serviceOrder?.currency?.code }}
            </span>

            {{ invoiceDetails.serviceOrder?.total | number: '1.2-2' }}
          </ng-container>
        </div>

        <!-- </div> -->
      </div>
    </div>
  </section>

  <div class="card-body">
    <form [formGroup]="invoiceForm" (ngSubmit)="onSubmit()">
      <div class="row mb-4">
        <div class="col-sm-2">
          <div class="form-group">
            <label for="serviceDate" class="mb-2">
              Supply Date <span class="text-danger">*</span>
            </label>
            <input
              [owlDateTime]="dt1"
              [min]="minDate"
              [ngClass]="{
                'is-invalid':
                  invoiceForm.get('serviceDate')?.hasError('required') &&
                  invoiceForm.get('serviceDate')?.touched
              }"
              [owlDateTimeTrigger]="dt1"
              class="form-control"
              formControlName="serviceDate"
              placeholder="Select Service Date" />
            <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
            <span class="error invalid-feedback">Please select a date</span>
          </div>
        </div>
        <div class="col-md-3">
          <div class="form-group">
            <label for="ebsReason" class="mb-2"
              >EBS Reason <span class="text-danger">*</span></label
            >
            <ng-select
              id="ebsReason"
              name="ebsReason"
              formControlName="ebsReason"
              [items]="reasonOptions"
              bindLabel="reason"
              bindValue="id"
              [searchable]="true"
              [clearable]="true"
              placeholder="Select Reason"
              [ngClass]="{
                'is-invalid':
                  invoiceForm.get('ebsReason')?.hasError('required') &&
                  (invoiceForm.get('ebsReason')?.touched ||
                    invoiceForm.get('ebsReason')?.dirty)
              }">
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <div>
                  <span class="rectangle-tag bg-info mr-2">{{
                    item.reason
                  }}</span>
                  <span
                    *ngIf="item.description"
                    class="rectangle-tag bg-success mr-2">
                    {{ item.description }}
                  </span>
                </div>
              </ng-template>
            </ng-select>
            <span
              *ngIf="
                invoiceForm.get('ebsReason')?.hasError('required') &&
                (invoiceForm.get('ebsReason')?.touched ||
                  invoiceForm.get('ebsReason')?.dirty)
              "
              class="error invalid-feedback"
              >Please select a reason</span
            >
          </div>
        </div>
        <div class="col-md-3">
          <label for="zatcaReason" class="mb-2"
            >Zatca Reason <span class="text-danger">*</span></label
          >
          <textarea
            type="text"
            class="form-control"
            formControlName="zatcaReason"
            placeholder="Enter ZATCA reason"
            [ngClass]="{
              'is-invalid':
                invoiceForm.get('zatcaReason')?.invalid &&
                invoiceForm.get('zatcaReason')?.touched
            }"></textarea>
          <span
            *ngIf="
              invoiceForm.get('zatcaReason')?.invalid &&
              invoiceForm.get('zatcaReason')?.touched
            "
            class="error invalid-feedback"
            >Please enter reason</span
          >
        </div>
      </div>
      <div formArrayName="lineItems">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Action</th>
              <!-- <th>Id</th> -->
              <th>Description</th>
              <th>Invoiced Quantity</th>
              <th>Invoiced Unit Price</th>
              <th>VAT (%)</th>
              <th>Credited Quantity<span class="text-danger">*</span></th>
              <th>Credited Unit Price<span class="text-danger">*</span></th>
              <!-- <th>Supply Date</th> -->
              <!-- <th>EBS Reason<span class="text-danger">*</span></th>
              <th>ZATCA Reason<span class="text-danger">*</span></th> -->
            </tr>
          </thead>

          <tbody>
            <tr
              *ngFor="let item of lineItems.controls; let i = index"
              [formGroupName]="i">
              <td>
                <mat-slide-toggle
                  formControlName="isActive"
                  (change)="onToggleLine(i); calculateTotals()"
                  color="primary"
                  class="strike-toggle">
                </mat-slide-toggle>
              </td>

              <!-- <td>{{ item.value.lineItemId }}</td> -->
              <td>{{ item.value.description || '' }}</td>
              <td>{{ item.value.quantity }}</td>
              <td>{{ item.value.unitPrice | number: '1.2-2' }}</td>
              <td>
                <ng-container *ngIf="!isFinanceCreditNote()">
                  {{ item.value.vat }}
                </ng-container>
                <ng-container *ngIf="isFinanceCreditNote()">
                  <ng-container *ngIf="!canEditCreditNoteVat()">
                    {{ formatVatDisplay(item.get('vat')?.value) }}
                  </ng-container>
                  <ng-select
                    *ngIf="canEditCreditNoteVat()"
                    formControlName="vat"
                    [items]="creditNoteVatOptions"
                    [clearable]="false"
                    [searchable]="false"
                    (change)="calculateTotals()">
                    <ng-template ng-label-tmp let-vatItem="item">
                      {{ vatItem.percentage }}%
                    </ng-template>
                    <ng-template ng-option-tmp let-vatItem="item">
                      {{ vatItem.percentage }}%
                    </ng-template>
                  </ng-select>
                </ng-container>
              </td>
              <td class="col-sm-2">
                <input
                  type="text"
                  class="form-control"
                  formControlName="creditedQuantity"
                  (input)="calculateTotals()"
                  [disabled]="isFlightPriceItem(item)"
                  placeholder="Enter credited qty"
                  [ngClass]="{
                    'is-invalid':
                      item.get('creditedQuantity')?.invalid &&
                      item.get('creditedQuantity')?.touched &&
                      item.get('creditedQuantity')?.dirty
                  }" />

                <div
                  *ngIf="
                    item.get('creditedQuantity')?.dirty ||
                    item.get('creditedQuantity')?.touched
                  "
                  class="text-danger small mt-1">
                  <div
                    *ngIf="
                      item.get('creditedQuantity')?.hasError('required') ||
                      item.get('creditedQuantity')?.hasError('min')
                    ">
                    Please enter a valid number.
                  </div>
                  <div
                    *ngIf="item.get('creditedQuantity')?.hasError('pattern')">
                    {{
                      module === 'AIRPORT_MANAGEMENT_SERVICE'
                        ? 'Decimal values are allowed (e.g. 1.5).'
                        : 'Only whole numbers are allowed.'
                    }}
                  </div>

                  <div *ngIf="item.hasError('creditedQuantityExceeds')">
                    Credited quantity cannot exceed original quantity ({{
                      item.value.quantity
                    }}).
                  </div>
                </div>
              </td>
              <td class="col-sm-2">
                <input
                  type="number"
                  class="form-control"
                  formControlName="creditedUnitPrice"
                  (input)="calculateTotals()"
                  placeholder="Enter credited unit price"
                  [ngClass]="{
                    'is-invalid':
                      item.get('creditedUnitPrice')?.invalid &&
                      item.get('creditedUnitPrice')?.touched &&
                      item.get('creditedUnitPrice')?.dirty
                  }" />

                <div
                  *ngIf="
                    item.get('creditedUnitPrice')?.dirty ||
                    item.get('creditedUnitPrice')?.touched
                  "
                  class="text-danger small mt-1">
                  <div
                    *ngIf="item.get('creditedUnitPrice')?.hasError('required')">
                    Please enter a valid number.
                  </div>

                  <div *ngIf="item.hasError('creditedUnitPriceExceeds')">
                    Credited unit price cannot exceed original quantity ({{
                      item.value.unitPrice
                    }}).
                  </div>
                  <div *ngIf="item.get('creditedUnitPrice')?.hasError('min')">
                    Credited unit price must be at least 1
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row justify-content-end">
        <div class="col-md-6">
          <div class="table-responsive">
            <table class="table">
              <tbody>
                <!-- Add this to your totals table -->

                <tr>
                  <td class="font-weight-bold detail-font-style">
                    Total (Excluding VAT) :
                  </td>
                  <td class="detail-font-style">
                    <span>{{ invoiceDetails.quotation?.currency?.code }}</span>
                    {{ totalExcludingVat | number: '1.2-2' }}
                  </td>
                </tr>

                <tr>
                  <td class="font-weight-bold detail-font-style">
                    Total Out Of Scope :
                  </td>
                  <td class="detail-font-style">
                    <span>{{ invoiceDetails.quotation?.currency?.code }}</span>
                    {{ totalOutOfScope | number: '1.2-2' }}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold detail-font-style">
                    Total Taxable Amount :
                  </td>
                  <td class="detail-font-style">
                    <span>{{ invoiceDetails.quotation?.currency?.code }}</span>
                    {{ totalTaxableAmount | number: '1.2-2' }}
                  </td>
                </tr>
                <tr>
                  <td class="font-weight-bold detail-font-style">
                    Total VAT (15%) :
                  </td>
                  <td class="detail-font-style">
                    <span>{{ invoiceDetails.quotation?.currency?.code }}</span>
                    {{ totalVat | number: '1.2-2' }}
                  </td>
                </tr>

                <tr>
                  <td class="font-weight-bold detail-font-style">Total :</td>
                  <td class="detail-font-style">
                    <span>{{ invoiceDetails.quotation?.currency?.code }}</span>
                    {{ totalAmount | number: '1.2-2' }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="text-right mt-3">
        <button type="button" class="btn btn-secondary" (click)="goBack()">
          Cancel
        </button>
        <button
          type="submit"
          class="btn btn-primary ml-2"
          [disabled]="
            invoiceForm.invalid ||
            partialCreditLoader ||
            !hasAtLeastOneActiveLine()
          ">
          <ng-container *ngIf="partialCreditLoader">
            <span class="spinner-border spinner-border-sm"></span>
          </ng-container>
          <ng-container *ngIf="!partialCreditLoader">Submit</ng-container>
        </button>
      </div>
    </form>
  </div>
</ng-container>
